import React from 'react';
import { SmileOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { usePermission } from '@contexts/Auth/UsePermission';
import ContainerBody from '@components/ContainerBody';
import Page403 from '@page/Common/403/403';

const LeakDetectorStatistics = () => {
  const navigate = useNavigate();
  const { leakDetector } = usePermission();

  const handleNavigate = () => {
    navigate('/dashboard');
  };

  if (!leakDetector.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <Result
      status="404"
      title="Đang cập nhật..."
      subTitle="Xin lỗi, trang này không tồn tại hoặc đang được liên tục cập nhật."
      extra={
        <Button type="primary" onClick={handleNavigate}>
          Quay lại trang chủ
        </Button>
      }
    />
  );
};

export default LeakDetectorStatistics;
